"use client"

import type { WhitelabelTemplateValue } from "@src/config/featureFlags"
import { useQuery } from "@tanstack/react-query"
import { type ReactNode, createContext } from "react"

export interface FeatureFlagValues {
  whitelabelTemplate: WhitelabelTemplateValue
  isSwapDisabled: boolean
  isDepositsDisabled: boolean
  isWithdrawDisabled: boolean
  isDealsDisabled: boolean
  isEarnDisabled: boolean
  isTradeDisabled: boolean
  perpsGeoBlocked: boolean
  isReferralDisabled: boolean
  isPromotionsDisabled: boolean
}

const DEFAULT_FLAGS: FeatureFlagValues = {
  whitelabelTemplate: "near-intents",
  isSwapDisabled: false,
  isDepositsDisabled: false,
  isWithdrawDisabled: false,
  isDealsDisabled: false,
  isEarnDisabled: false,
  isTradeDisabled: false,
  perpsGeoBlocked: false,
  isReferralDisabled: false,
  isPromotionsDisabled: false,
}

export const FeatureFlagsContext =
  createContext<FeatureFlagValues>(DEFAULT_FLAGS)

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  const { data: flags = DEFAULT_FLAGS } = useQuery({
    queryKey: ["feature-flags"],
    staleTime: 30_000,
    queryFn: async () => {
      const res = await fetch("/api/feature-flags")
      if (!res.ok) throw new Error(`Flag fetch failed: ${res.status}`)
      return res.json() as Promise<FeatureFlagValues>
    },
  })

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
